var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex f-100 wrapped jc-center"},[_c('Checklist',{attrs:{"title":"Liste a jornada operacional dos profissionais:","list":_vm.service.responsabilities},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }